<template>
    <div class="boddy" ref="boddy">
<!-- <Header2 class="titlehed"></Header2> -->
        <Header :isScrolled="isScrolled"></Header>

        <div class="section imgone"  >
            <img :src="imageUrlone" alt="">
        </div>
        <div class="" ref="secondSection">
            
            <div class="product-container">
            <div v-for="(product, productIndex) in products" :key="productIndex" class="product"  :class="{ 'two-per-row': products.length === 4}">
                <div class="product-image">
                    <!-- 确保选择的颜色存在 -->
                    <img :src="product.colors[product.selectedColorIndex]?.image" alt="Product Image">
                </div>

                <div class="color-selector">
                    <!-- 遍历颜色，生成颜色小圆点 -->
                    <div v-for="(color, index) in product.colors" :key="index"
                        class="color-dot"
                        :class="{ selected: product.selectedColorIndex === index }"
                        :style="{ backgroundImage: `url(${color.image})` }"
                        @click="selectColor(productIndex, index)">
                        <p v-if="product.selectedColorIndex === index">{{ isEnglish ?color.colorDescriptionen: color.colorDescription }}</p>
                    </div>
                </div>

                <div class="product-info">
                    <p> {{ isEnglish ?product.colors[product.selectedColorIndex]?.modelen: product.colors[product.selectedColorIndex]?.model }}</p>
                    <p>{{ isEnglish ?product.colors[product.selectedColorIndex]?.sizeen: product.colors[product.selectedColorIndex]?.size }}</p>
                    <p>{{ isEnglish ?product.colors[product.selectedColorIndex]?.materialen : product.colors[product.selectedColorIndex]?.material }}</p>
                    <p>{{ isEnglish ?product.colors[product.selectedColorIndex]?.discritpen : product.colors[product.selectedColorIndex]?.discritp }}</p>

                    <p> {{ isEnglish ?product.colors[product.selectedColorIndex]?.priceen : product.colors[product.selectedColorIndex]?.price }}</p>
                </div>
            </div>
            </div>
        </div>
        <div  class="section" v-if="isvideos">
          
            <!-- 插入视频 -->
            <video controls autoplay muted loop  ref="videoPlayer" class="videos1">
                <source :src="videoSource" type="video/mp4">
                <!-- 提示信息：当浏览器不支持 video 标签时显示 -->
                Your browser does not support the video tag.
            </video>
           
        
        </div>
        
        <!-- 添加更多 section -->
        <!-- <Bottom2></Bottom2> -->
        <Bottom></Bottom>
    </div>
</template>

<script>
    import Header from'@/view/public/heardpc.vue'
    // import Bottom2 from "@/view/public/heardpc.vue";
    // import Header2 from '../public/newheaderx.vue'
    import Bottom from "@/view/public/bottompc.vue";
    import { mapActions, mapState } from 'vuex';
    import axios from 'axios';
    import apiUrls from '@/http/http'; // 假设 http.js 在 src/http 目录下
    export default {
        computed: {
           // 从 Vuex 的 state 中获取 isEnglish 数据
           ...mapState(['isEnglish']), // 这里读取 state 中的 isEnglish 状态
              // Vuex 的 actions 映射到 methods
              ...mapActions(['changeLanguage']),
          
             
        },
        components:{
            // Header2,
            Header,
            // Bottom2,
            Bottom
        },
        data() {
            return {
                maxColorIndex: 2, // 假设有6种颜色，索引从0到5  
                ss:0,
                isvideos:false,//是否播放视频
                videoSource: '', // 初始视频源路径
                isScrolled: false,
                // imageUrlone: require('../../assets/pukipicsss-16.jpg'), // 动态传递的图片路径
                imageUrlone: '', // 动态传递的图片路径
                products: [
                    {
                        selectedColorIndex: 0, // 默认选中的颜色的索引
                        colors: [
                            {
                                id:0,
                                // image:  require('../../assets/p0118pic-23.jpg'),
                                image:  "",
                                colorDescription: '宝石红',
                                size: '18英寸',
                                model: 'P0118',
                                material: '铝镁合金',
                                price: '3499元',
                                colorDescriptionen: '宝石红',
                                sizeen: '18英寸',
                                modelen: 'P0118',
                                materialen: '铝镁合金',
                                discritp: "颜色可定制",
                                discritpen: "暂无",
                            },
                         
                           
                          
                            {
                                id:0,
                                // image:  require('../../assets/p0118pic-23.jpg'),
                                image:  "",
                                colorDescription: '宝石红',
                                size: '18英寸',
                                model: 'P0118',
                                material: '铝镁合金',
                                price: '3499元',
                                colorDescriptionen: '宝石红',
                                sizeen: '18英寸',
                                modelen: 'P0118',
                                materialen: '铝镁合金',
                                 priceen: '3499元',
                                 discritp: "颜色可定制",
                                discritpen: "暂无",
                            },
                        ]
                    }
                    
                    
                ],
                ascription: 'indexmain',  // 可以根据实际需求动态设置
                videoSource:'',
            };
           
        },

        mounted() {
            // 初次加载时立即调用一次 fetchData，确保使用当前的 isEnglish
            this.fetchData(this.$route.params.id);
            

            window.addEventListener('wheel', this.handleScroll, { passive: false });
            this.$refs.boddy.addEventListener('scroll', this.debouncedHandleScroll);

            this.initObserver(); // 初始化观察器
           this.getVideosByAscription(this.$route.params.id);
        },
        beforeDestroy() {

            this.$refs.boddy.removeEventListener('scroll', this.debouncedHandleScroll);
            window.removeEventListener('wheel', this.handleScroll);
        },
        methods: {
            selectColor(productIndex, colorIndex) {
      this.products[productIndex].selectedColorIndex = colorIndex;
    },
    startColorRotation() {
      this.products.forEach((product, productIndex) => {
         // 第一次立即切换
            const initialIndex = Math.floor(Math.random() * product.colors.length);
            this.selectColor(productIndex, initialIndex);
        setInterval(() => {
          // 生成随机颜色索引
          const randomIndex = Math.floor(Math.random() * product.colors.length);
         
          this.selectColor(productIndex, randomIndex);
        }, 2000); // 每2秒切换一次颜色
      });
    },
            // 发送请求获取视频数据
            getVideosByAscription(ascription) {
                axios.get(`${apiUrls.baseUrl}/website/api/Pukivideos`, {
                    params: {
                    ascription: ascription
                    }
                })
                .then(response => {
                      // 将响应数据赋值给 videos
                     // 从响应中获取视频 URL 并赋值
                        // const videoUrl = `${apiUrls.devApi}${response.data[0].pukivideos}`;
                        // this.indexmainvideos = videoUrl; // 更新 indexmainvideos
                        // console.log('视频路径:', videoUrl);

                        // 将响应数据赋值给 videos
                        const data = response.data[0];
                    this.videoSource=`${apiUrls.devApi}${data.pukivideos}`;
                    //   console.log("shiping:"+this.videoSource )
                })
                .catch(error => {
                    console.log(null);
                });
                },
             /**
             * 获取页面数据
             */
             async fetchData(collectionkey) {
                
                            try {
                                
                            // 发起API请求
                            const response = await axios.get(`${apiUrls.baseUrl}/website/api/getcollectionkey`,{
                            params:{
                                collectionkey: collectionkey,
                            }
                        });
                        
                        const videoMap = {

                            collectionA: {
                                isvideos: true,
                                videoSource: this.videoSource
                            },
                            collectionE: {
                                isvideos: true,
                                videoSource: this.videoSource
                            },
                            collectionU: {
                                isvideos: true,
                                videoSource: this.videoSource
                            },
                            collectionK: {
                                isvideos: true,
                                videoSource: this.videoSource
                            },
                            collectionC: {
                                isvideos: true,
                                videoSource: this.videoSource
                            }
                            // 可以添加其他 collectionKey 映射...
                        };
                        // 根据 collectionkey 查找对应的视频配置
                        const videoConfig = videoMap[collectionkey] || { isvideos: false, videoSource: null };
                        // 使用解构赋值来设置 isvideos 和 videoSource
                        this.isvideos = videoConfig.isvideos;
                        this.videoSource = videoConfig.videoSource;

                        const relativeImageUrl = response.data[0].imageUrlone;
                          this.imageUrlone=`${apiUrls.devApi}${relativeImageUrl}`;
                         
                            if (response.data && response.data.length > 0) {
                              
                              this.products=response.data.map(product=>{
                                const images = product.image.split(','); // 将图片路径字符串转换为数组
                                const colors = product.colorDescription.split(','); // 将颜色字符串转换为数组
                                 const colorsen = product.colorDescriptionen.split(','); // 将颜色字符串转换为数组
                                    // 检查数组长度
                // console.log('Images:', images.length, 'Colors:', colors.length);
                                // 构建 colors 数组
                                    const colorsArray = images.map((image, index) => ({
                                        image:`${apiUrls.devApi}${image}`,  // 每个图片路径
                                        colorDescription: colors[index]?.trim(),  // 颜色描述（去除空格）
                                        size: product.size,
                                        model: product.model,
                                        material: product.material,
                                        price: product.price,
                                        colorDescriptionen: colorsen[index]?.trim(),  // 颜色描述（去除空格）
                                        sizeen: product.sizeen,
                                        modelen: product.modelen,
                                        materialen: product.materialen,
                                        priceen: product.priceen,
                                        priceen: product.priceen,
                                        discritp: product.discritp,
                                         discritpen: product.discritpen,
                                         id:product.id,
                                         
                                    }));
                              
                                     // 返回处理后的产品对象
                                    return {
                                         
                                        selectedColorIndex: 0 ,  // 默认选中的颜色索引
                                        colors: colorsArray  // 生成的 colors 数组
                                    };

                              })
                                
                             
                            }
                            } catch (error) {
                            console.error('获取数据失败:', error);
                            }
                            this.startColorRotation(); // 组件加载时启动颜色轮播
                            },


            selectColor(productIndex, colorIndex) {
                this.products[productIndex].selectedColorIndex = colorIndex;
            },

            initObserver() {
                // console.log(this.isEnglish)
                const options = {
                    root: this.$refs.boddy,
                    rootMargin: '0px',
                    threshold: 0.1 // 10% 进入视口时触发
                };
// 只观察第二个 section
                // 只观察第二个 section
                const observer = new IntersectionObserver((entries) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            this.isScrolled = true; // 当第二个 section 进入视口时设置 isScrolled = true
                        }
                    });
                }, options);
                const secondSection = this.$refs.secondSection; // 监视第二个 section
                if (secondSection) {
                    observer.observe(secondSection);
                }

            },


            handleScroll(event) {
                if (event.deltaY !== 0) {
                    const isMobile = window.innerWidth < 768;
                    if (isMobile) {
                        return; // 如果是手机界面，直接返回，取消滚动效果
                    }
                    const scrollContainer = this.$refs.boddy;
                    if (scrollContainer.scrollTop === 0) {
                        this.scrollCount = 0;
                    }

                    const scrollHeight = scrollContainer.scrollHeight;
                    const containerHeight = scrollContainer.clientHeight;
                    // 检查滚动位置并设置 isScrolled
                    // 滚动状态判断
                    const scrollTop = scrollContainer.scrollTop;
                    if (scrollTop === 0) {
                        this.isScrolled = false;
                    } else if (scrollTop + containerHeight >= scrollHeight) {
                        this.isScrolled = true;
                    } else {
                        this.isScrolled = true;
                    }
                    let height;
                        height = window.innerHeight;
                        scrollContainer.scrollBy({

                            top: event.deltaY > 0 ? height : -height,
                            behavior: 'smooth'
                        });


                    this.scrollCount += 1; // 增加滚动计数
                    // 等待 DOM 更新后再检查可见的 sections
                    setTimeout(() => {
                        // 先移除 fadeIn 类，强制重绘
                        const contents = scrollContainer.querySelectorAll('.content');
                        contents.forEach(content => {
                            content.classList.remove('fadeIn'); // 先移除
                            void content.offsetWidth; // 强制重绘
                        });

                        // 重新添加 fadeIn 类到当前可见的 .content
                        //this.checkVisibleSections(); // 检查可见的 sections

                        // 第一次滚动时，立即添加动画
                        if (this.scrollCount === 0) {
                            contents.forEach(content => {
                                content.classList.add('fadeIn'); // 立即添加动画类
                            });
                        }
                    }, 100); // 调整延迟时间以确保 DOM 更新后再执行




                    event.preventDefault();
                }
            },
            debounce(func, wait) {
                let timeout;
                return function(...args) {
                    const context = this;
                    clearTimeout(timeout);
                    timeout = setTimeout(() => func.apply(context, args), wait);
                };
            },
        }
    }
</script>
<style scoped>
video{
    height: 97vh;
    width: 100%;
    object-fit: cover;
}
/* 产品卡片的样式开始 */
.product-container {
    background-color: white;
        display: flex;
        flex-wrap: wrap; /* 允许换行 */
        justify-content: center; /* 水平居中 */
        text-align: center;
        /* padding-top: 3vh; 整体容器向下移动 20px */
    }
    .product{
        height: 93vh;
        width: 100vw;
        flex: 0 0 30%; /* 每个产品占据 30% 的宽度 */
       
       padding-top: 7vh;
    }
    
    /* 产品数量为4时的样式 */
.two-per-row {
  flex: 0 0 34%; /* 每个产品占50% */
 
}

    .product-image img {
        width: 300px;
        height: auto;
    }

    .color-selector {
        display: flex;
        justify-content: center;
        margin-top: 10px;
    }

    .color-dot {
        width: 1.2rem;
        height: 1.2rem;
        border-radius: 50%;
        margin: 0 0.5rem;
        cursor: pointer;
        border: 0.1rem solid transparent;
        background-size: 100000%;
        background-position: 40% ;
        box-shadow: none;
        transition: box-shadow 0.3s ease;
    }

    .color-dot.selected {
        box-shadow: 0 0 0 0.3rem white, 0 0 0 0.4rem #555555;
    }

    .color-dot p {
        text-align: center;
        margin-top: 2rem;
        margin-left: -0.3rem;
        font-size: 0.6rem;
        color: #555555;
        white-space: nowrap;
    }

    .product-info {
        padding-top: 1rem;
    }
/* 产品卡片的样式结束 */
.imgone img{
    width: 100%;
    height: auto;
    margin-bottom: 10vh;
    
}
    .fadeIn {
        animation: fade-in ease 2s !important; /* 添加 !important 提高优先级 */
        animation-fill-mode: forwards;
    }
    @keyframes fade-in {
        from {
            opacity: 0;
            transform: translateY(100px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    .red{
        background-color: red;
    }
/*整体布局开始*/
.boddy {
height: 100vh;


overflow-y: auto; /* 允许垂直滑动 */
}
/* 隐藏滚动条，适用于Webkit浏览器（如Chrome、Safari） */
.boddy::-webkit-scrollbar {
display: none;
}

/* 隐藏滚动条，适用于Firefox */
.boddy {
scrollbar-width: none; /* Firefox */
}

/* 隐藏滚动条，适用于Internet Explorer 和 Edge */
.boddy {
-ms-overflow-style: none; /* Internet Explorer 和 Edge */
}

/*整体布局结束*/
/*内容部分开始*/
.section{
    height: 97vh;
    display: flex;
    justify-content: center;
    align-items: center;
}
/*内容部分结束*/
.titlehed{
    display: none;

}
/*手机端样式开始*/
@media screen and (max-width: 768px) {
    .product{
        padding-top: 0vh;
        height: 80vh;
    }
    .section{
        height: auto;
    }
    .imgone img{
        width: 100vw;
        height: auto;
        margin-bottom: 0;
    }

    .titlehed{
        display: block!important;
        height: 10rem!important;
    }

}
/*手机端样式结束*/
</style>
